import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Spinner from './components/common/spinner/Spinner';
import SystemNotices from './components/common/system-notices/SystemNotices';

import AuthContainer from './containers/auth/Auth.container';
import ProgrammeContainer from './containers/programme/Programme.container';
import SettingsContainer from './containers/settings/Settings.container';

import './stylesheets/app.scss';

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/*" element={<AuthContainer />} />
        <Route path="/programmes/*" element={<ProgrammeContainer />} />
        <Route path="/settings" element={<SettingsContainer />} />
      </Routes>
      <SystemNotices />
      <Spinner />
    </div>
  );
}

export default App;
